/**
 *    User registration - Toggle on change
 */

(function ($) {
  Drupal.behaviors.userRegistrationToggleOnChange = {
    attach() {
      $('[data-toggle-oc]').on('change', function () {
        const $this = $(this);
        const value = $this.val();
        const valueShow = $this.attr('data-toggle-oc-show-value');
        const $target = $(`#${$this.attr('data-toggle-oc')}`);

        // show/hide target
        $target.toggleClass('hide', !(value === valueShow));
      }).change();
    },
  };
}(jQuery));
